import FR from './FR.json';
import EN from './EN.json';

export const dictionaryList = { EN, FR };

export const languageOptions = {
  EN: 'EN',
  FR: 'FR',
};